<div *ngIf="corrected" class="font-xs">
  <span [translate]="'notifications.information.emailSuggestion'"></span>&nbsp;<span class="fw-bold">{{corrected}}</span>
</div>
